export default "__VITE_ASSET__qP_r83IlryRG0BoT2_MBkA__"